module.exports = __webpack_public_path__ + "static/media/1005374.bbabea4e.jpg";